import {Component, Input, OnInit} from '@angular/core';
import {CloseGuard, DialogRef, ModalComponent} from 'ngx-modialog';
import {ApiService} from '../../../utils/services/api.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CreditCardProvider} from '../../../utils/objects/organization-parameter';
import {PAYMENT_GATEWAYS, CC_3D_STORETYPES} from '../../../utils/constants/constants';
import {Observable} from 'rxjs/Observable';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-credit-card-info',
  templateUrl: './credit-card-info.component.html',
  styleUrls: ['./credit-card-info.component.css']
})
export class CreditCardInfoComponent implements OnInit, CloseGuard, ModalComponent<any> {

  public organizationParameterForm: FormGroup;
  public ccProvider: CreditCardProvider;
  public organizationID;
  public paymentGateways = PAYMENT_GATEWAYS;
  public storeTypes = CC_3D_STORETYPES;


  constructor(public dialog: DialogRef<any>,
              private apiService: ApiService,
              private notificationsService: NotificationsService) {
    this.organizationID = this.dialog.context.organizationID;
    this.ccProvider = this.dialog.context.flightProvider;
    dialog.setCloseGuard(this);
  }

  ngOnInit() {
    this.organizationParameterForm = new FormGroup({
      'provider': new FormControl(null, Validators.required),
      'username': new FormControl(null, Validators.required),
      'password': new FormControl(null, Validators.required),
      'clientid': new FormControl(null, Validators.required),
      'storekey': new FormControl(null),
      'storetype': new FormControl(null),
      'url_service': new FormControl(null),
      'url_3d': new FormControl(null),
    });
    if (this.ccProvider) {
      this.organizationParameterForm.patchValue({
        provider: this.ccProvider.provider ? this.ccProvider.provider:this.paymentGateways[0],
        storekey: this.ccProvider.storekey ? this.ccProvider.storekey.value : null,
        storetype: this.ccProvider.storetype ? this.ccProvider.storetype.value : null,
        url_service: this.ccProvider.url_service ? this.ccProvider.url_service.value : null,
        url_3d: this.ccProvider.url_3d ? this.ccProvider.url_3d.value :null
      });
    }else{
      this.organizationParameterForm.controls.provider.patchValue(this.paymentGateways[0]);
    }
  }

  closeModal() {
    this.dialog.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return false;
  }

  saveFlightProvider() {
    let requests: Array<Observable<any>> = [];
    const provider = this.organizationParameterForm.controls.provider.value;
    if(this.organizationParameterForm.invalid){
      this.notificationsService.warn('Warn', 'Please fill required field');
      return;
    }
     for (let control in this.organizationParameterForm.controls){
        if(control === 'provider'){
          continue;
        }
        if (this.ccProvider && this.ccProvider[control]) {
          requests.push(
                this.createPutRequest(
                  this.ccProvider[control].id,
                  provider,
                  control,
                  this.organizationParameterForm.get(control).value
                ))
        } else if (this.organizationParameterForm.get(control).value){
          requests.push(
            this.createPostRequest(
              provider,
              control,
              this.organizationParameterForm.get(control).value
          ));
        }
     }

    Observable.forkJoin(requests).subscribe(
      response => {
        this.notificationsService.success('Success', 'Credit card provider is added');
        this.dialog.close(response);
      }, error => {
        this.notificationsService.error('Error', 'Error occured');
      }
    );

  }

  createPostRequest(context, key, value): Observable<any> {
    return this.apiService.addOrganizationParameter(this.organizationID, {
      type: 'PaymentGateway',
      context: context,
      key: key,
      value: value
    });
  }

  createPutRequest(parameterID: number, context, key, value): Observable<any> {
    return this.apiService.updateOrganizationParameter(this.organizationID, parameterID, {
      type: 'PaymentGateway',
      context: context,
      key: key,
      value: value
    });
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/credit-card-info/credit-card-info.component.ts